module.exports = {
	"auctioneer": {
		"notOngoing": "This auction is not ongoing. It needs to be ongoing to access the auctioneer interface."
	},
	"cannotEdit": "Cannot edit this auction currently.",
	"cannotEditLong": "Please note that you cannot edit an auction while it is in progress or has already been published or cancelled.",
	"cannotPublish": "You cannot publish this auction until you add at least one lot in the list.",
	"linkAuctioneer": "Auctioneer interface",
	"linkAuctionControl": "Control live auction",
	"linkAuctionHistory": "Event history",
	"linkAuctionReport": "Auction report",
	"linkMonitor": "Public display",
	"linkPicture": "Auction picture",
	"linkSettings": "Auction settings",
	"name": "Auction name",
	"scheduled": "Scheduled Date / Time",
	"type": "Type",
	"typeLive": "Live auction",
	"typeOnline": "Online-only auction",
	"publish": {
		"publish": "Publish",
		"confirm": "Are you sure you want to publish the auction? $t(general::cannotUndo)",
		"success": "Your auction was successfully published!"
	},
	"cancel": {
		"cancel": "Cancel auction",
		"confirm": "Are you sure you want to cancel the auction? You will lose all bids made by participants thus far. $t(general::cannotUndo)",
		"success": "Your auction was successfully cancelled! Participants will be notified."
	},
	"auctionControl": {
		"header": "Control the live auction",
		"auctionCancelled": "The auction was cancelled, you cannot start it.",
		"auctionLive": "The auction is in progress!",
		"auctionOver": "The auction is over. Would you like to consult the event history?",
		"auctionReady": "The auction hasn't started yet.",
		"auctionUnpublished": "The auction hasn't started yet. To start the auction you must first publish it.",
		"startButton": "START THE LIVE AUCTION"
	},
	"auctionCreate": {
		"header": "Create new auction",
		"createBtn": "Create auction"
	},
	"auctionHistory": {
		"header": "Event history"
	},
	"auctionIncrements": {
		"header": "Bid increments"
	},
	"auctionNumberOfLots": "You don't have any lots registered for this auction. However, since you set this auction to not have pre-bidding, you can simply indicate the number of lots and then publish it.",
	"auctionList": {
		"addAFirstOne": "You can add a first one by clicking here",
		"addLotBtn": "Add a lot",
		"auctionsList": "Auction list",
		"createAuctionBtn": "Create an auction",
		"empty": "The auction list is empty!",
		"header": "Auction list",
		"manageAuctionBtn": "Manage auction",
		"noLotsForNow": "This auction has no lot for now.",
		"rankChanged": "You have changed the rank order of this auction. The items with a new rank have been highlighted in blue and the items you moved yourself have been highlighted in yellow. Decide whether you want to save these changes or discard them.",
		"status": "Status"
	},
	"auctionLiveBidding": {
		"description": "This auction will have a live bidding event",
		"name": "Live bidding"
	},
	"auctionPermissions": {
		"header": "Permissions & bid limits",
		"allowed": "Allowed",
		"bidInLiveAuction": "Bid in live auction",
		"bidLimit": "Bid limit",
		"insertListPermissions": "Insert user list specific permissions",
		"manageUsersList": "Manage user lists",
		"notAllowed": "Not allowed",
		"noUserList": "You don't have any other user lists that you can add.",
		"previewCatalog": "Preview catalog",
		"purchaseLimit": "Total purchase limit",
		"selectUserList": "Select a user list to add permissions to",
		"specificAmount": "Specific amount",
		"unlimited": "Unlimited",
		"viewLiveAuction": "View live auction"
	},
	"auctionPicture": {
		"header": "Auction Picture",
		"auctionPictureLabel": "Thumbnail picture"
	},
	"auctionReport": {
		"header": "Auction report"
	},
	"auctionSettings": {
		"header": "Auction profile settings",
		"updateBtn": "Update information"
	},
	"auctionTerms": "Use this field to describe the rules of conduct, policies and conditions of participation of your auction.",
	"auctionUserList": {
		"addEmail": "Add e-mail invite",
		"addToken": "Add token",
		"allUnverified": "All __brand__ unverified buyers",
		"allVerified": "All __brand__ verified buyers",
		"cancelInvite": "Cancel invite",
		"cancelToken": "Cancel token",
		"create": "Create list",
		"createList": "Create a new list",
		"defaultUserList": "Default user list",
		"editList": "Edit list",
		"emailInvites": "E-mail invites",
		"explain": "You can add any e-mail to the user list, this will send them a notification even if they don't have an account. If they already have an __brand__ account, they will still receive a notification e-mail, but they will automatically be added to the members of the list.",
		"header": "List of users",
		"inviteEmail": "Add an e-mail invite for this list.",
		"inviteToken": "Add an access token for this list.",
		"label": "Send an invite to the following e-mail address:",
		"labelToken": "Use the following generated token or enter your own:",
		"members": "# Members",
		"memberUsers": "Members users",
		"modalCreateListLabel": "Enter a name to identify this list of users.",
		"modalCreateListPlaceholder": "Name of the list",
		"modalRemoveListLabel": "Are you sure you want to remove this list?",
		"noEmail": "No e-mail invites in this list.",
		"noLists": "You have no user lists.",
		"noMembers": "No members in this list.",
		"noToken": "No token invites in this list.",
		"pending": "# Pending Invites",
		"removeEmail": "Remove e-mail invite from list",
		"removeFromList": "Remove user from list",
		"removeList": "Remove list",
		"removeUser": "Remove user",
		"send": "Send invite",
		"token": "Token",
		"tokenInvites": "Token invites",
		"userLists": "User lists"
	},
	"bidReport": {
		"header": "Bids received report",
		"highestBid": "Highest bid",
		"receivedBids": "Received bids"
	},
	"userListRequests": {
		"menuName": "$t(oa-auction::userListRequests.name)",
		"name": "User list requests",
		"none": "There are currently no user list requests.",
		"userDenied": "User was denied access.",
		"userGranted": "User was added to <userListName />."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/oa-auction.json5
// module id = 1943
// module chunks = 6